/*
* Association search view for authenticated users
*/

import '@progress/kendo-ui';
import * as _ from 'lodash';
import * as React from 'react';
import { Alert, Label as RBLabel, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { compose } from 'redux';
import { connectRequest } from 'redux-query';

import * as AppComp from '../common/app-component-base';
import { BootstrapColXl as Col } from '../common/bootstrap/bootstrapcolxl';
import { Formatters } from '../common/formatters';
import { NavigationLinks } from '../common/navigation';
import { WhiteBoxPageSection } from '../common/whiteboxpagesection';
import ApiEndpoints from '../config/apiendpoints';
import { PortalRoles } from '../invite/create-invite';
import * as ReduxQueries from '../queries';
import { UserUtilities } from '../user/user-utilities';

class ClientDashboard extends AppComp.AppComponent {
    public constructor(props: any) {
        super(props, 'app.client-dashboard.');
    }

    public extendGridData(records: Array<any>) {
        // Extend search result records with additional dynamic field values for use in grid
        if (!records) { return []; }

        return records.map(r => {
            let record = Object.assign({}, r);

            let assoc = _.get(record, 'association');
            if (!assoc) { return record; }

            // Association Location
            record.associationLocation = Formatters.composeLocationCityState(assoc.location);
            let temp = record.associationLocation;
            temp = '';
            // Association name
            record.associationName = Formatters.getStr(assoc, 'name');

            // Association name link details
            record.associationDetailLinkHref = '';
            if (assoc.associationId) {
                record.associationDetailLinkHref = NavigationLinks.associationDetail(Formatters.getInt(assoc, 'associationId'));
            }

            // View inventory link
            record.viewInventoryLink = '';
            record.viewInventoryLinkHref = '';
            if (assoc.associationId) {
                record.viewInventoryLink = this.appText('view-inventory');
                record.viewInventoryLinkHref = NavigationLinks.associationInventory(Formatters.getInt(assoc, 'associationId'));
            }

            return record;
        });
    }

    public handleSearchFilter(e: any) {
        const keyword = e.target.value;
        // this.props.dispatch(Actions.searchClientDashboardKeyword(keyword));
    }

    public getPortalLink(associationId: any) {
        return NavigationLinks.portalAssociationReport(associationId);
    }

    public render() {
        const { search, ...rest } = this.props;

        if (!_.get(search, 'modelType')) { return (<div />); }

        const rows = this.extendGridData(search.results);

        const pageTitle = this.appTextResultsAndPageTitle(rows.length);

        const validPortalInvites: any = UserUtilities.GetValidPortalInvites(rows);

        const InviteAssocLink = ({ to, assocName, ...props }) => (
            <Link
                className="list-group-item clientdash-invite-assoc-link"
                to={to}
            >
                <span className="list-group-item-heading clientdash-invite-assoc-link-name">
                    <i className="glyphicon glyphicon-chevron-right" /> {assocName}
                </span>
                {props.children}
            </Link>
        );

        // Associations where role = PortalAdmin
        const filterAdmin = UserUtilities.FilterPortalInvites(validPortalInvites, PortalRoles.PortalAdmin.RoleName);
        // console.log(`validPortalInvites.len ${_.size(validPortalInvites)} filterAdmin.len ${_.size(filterAdmin)}`, {
        //     validPortalInvites: validPortalInvites,
        //     filterAdmin: filterAdmin,
        // });
        let managedAssociations = (<div />);
        if (_.size(filterAdmin)) {
            managedAssociations = (
                <Col xs={12} md={6}>
                    <WhiteBoxPageSection title={this.appText('managed-associations')}>
                        <div className="clientdash-admin-assoc-info">
                            <div className="list-group">
                                {filterAdmin.map((c) => {
                                    const assoc = _.get(c, 'association', {});

                                    return (
                                        <div key={`link-clientdash-admin-assoc-${Formatters.getStr(assoc, 'associationObjectId', '')}`}>
                                            {/* <InviteAssocLink                                                                                                             
                                                to={NavigationLinks.associationAnalysis(Formatters.getInt(assoc, 'associationId'))}
                                                assocName={Formatters.composeAssociationNameLabel(assoc, true)}
                                            >  */}
                                            <InviteAssocLink
                                                to={this.getPortalLink(Formatters.getInt(assoc, 'associationId'))}
                                                assocName={Formatters.composeAssociationNameLabel(assoc, true)}
                                            >
                                                <RBLabel bsSize="xs" bsStyle="info">{this.appTextPlural('invited-user', _.size(_.get(c, 'association.invites', [])), true, true)}</RBLabel>
                                            </InviteAssocLink>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </WhiteBoxPageSection>
                </Col>
            );
        }

        // Associations where role = PortalUser
        const filterUser = UserUtilities.FilterPortalInvites(validPortalInvites, PortalRoles.PortalUser.RoleName);
        let userAssociations = (<div />);

        if (_.size(filterUser)) {
            userAssociations = (
                <Col xs={12} md={6}>
                    <WhiteBoxPageSection title={this.appText('user-associations')}>
                        <div className="list-group">
                            {filterUser.map((c) => {
                                const assoc = _.get(c, 'association', {});

                                return (
                                    <InviteAssocLink
                                        key={`link-clientdash-user-assoc-${Formatters.getStr(assoc, 'associationObjectId', '')}`}
                                        to={this.getPortalLink(Formatters.getInt(assoc, 'associationId'))}
                                        assocName={Formatters.composeAssociationNameLabel(assoc, true)}
                                    />
                                );
                            })}
                        </div>
                    </WhiteBoxPageSection>
                </Col>
            );
        } else if (!_.size(filterUser) && !_.size(filterAdmin)) {
            userAssociations = (
                <Col xs={12} md={6}>
                    <WhiteBoxPageSection title={this.appText('user-associations')}>
                        <div className="clientdash-user-assoc-empty">
                            <Alert bsStyle="info">
                                <div>
                                    <h4>{this.appText('no-results')}</h4>
                                    <h5>
                                        <div>{this.appText('no-results.1')}</div>
                                        <div>{this.appText('no-results.2')}</div>
                                        <div>{this.appText('no-results.3')}</div>
                                    </h5>
                                </div>
                            </Alert>
                        </div>
                    </WhiteBoxPageSection>
                </Col>
            );
        }

        const page = (
            <Row>
                <Col xs={12} md={10}>
                    {managedAssociations}
                    {userAssociations}
                </Col>
            </Row>
        );

        return (
            <AppComp.RenderPageWithLayout branding={this.props.branding} pageName={pageTitle} {...rest}>
                {page}
            </AppComp.RenderPageWithLayout>
        );
    }
}

const getApiUrl = () => ApiEndpoints.getSearchClientDashboardUrl();

const mapPropsToConfigs = (props) => ReduxQueries.Queries.searchClientDashboardRequest(
    getApiUrl(),
    ReduxQueries.PropsAccessToken(props),
    _.get(props, 'search.term', ''),
    _.get(props, 'search.operator', '')
);

const mapStateToProps = (state, props) => {
    return ReduxQueries.MapQueryStateToPropsByUrl(getApiUrl(), state, props, {
        search: {
            operator: 'OR',
            results: state.entities.searchClientDashboardResults,
            term: state.searchFiltersClientDashboard.keyword,
            modelType: state.entities.searchClientDashboardModelType,
        }
    });
};

const ClientDashboardContainer = compose<any>(
    connect(mapStateToProps),
    connectRequest(mapPropsToConfigs)
)(ClientDashboard);

export default withRouter(ClientDashboardContainer);



// WEBPACK FOOTER //
// ./src/client-dashboard/index.tsx